import { HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import {
    ActivatedRoute,
    ActivatedRouteSnapshot,
    CanActivate,
    CanActivateChild,
    CanDeactivate,
    CanLoad,
    Route,
    Router,
    RouterStateSnapshot,
    UrlSegment,
    UrlTree
} from '@angular/router';
import { Observable } from 'rxjs';
import {
    DOCTOR_ROLES,
    OTHER_MEDICAL_PROFESSIONAL_ROLES,
    PATIENT_ROLES,
    SUPPORT_ROLES,
    VENDOR_ROLES
} from '../constant/constant';
import { AuthService } from '../services/auth.service';
import { ProviderStateService } from '../services/provider-state.service';


export class RouterData {
    role_type: string;
    sub_role: number[];
    constructor() {
        this.role_type = '';
        this.sub_role = [];
    }
}

@Injectable({
    providedIn: 'root'
})
export class UserRoleAuthorizeGuard
    implements CanActivate, CanActivateChild, CanDeactivate<unknown>, CanLoad {
    slug: string = "";
    constructor(
        private readonly authService: AuthService,
        private readonly router: Router,
        private readonly activatedRoute: ActivatedRoute,
        private readonly provoiderstateService: ProviderStateService
    ) {
        this.slug = this.provoiderstateService.getProviderSlug();
    }

    async canActivate(
        route: ActivatedRouteSnapshot,
        state: RouterStateSnapshot
    ): Promise<boolean | UrlTree> {
        return await this.RoleGaurd(route, state);
    }
    async canActivateChild(
        childRoute: ActivatedRouteSnapshot,
        state: RouterStateSnapshot
    ): Promise<boolean | UrlTree> {
        return await this.RoleGaurd(childRoute, state);
    }
    canDeactivate(
        component: unknown,
        currentRoute: ActivatedRouteSnapshot,
        currentState: RouterStateSnapshot,
        nextState?: RouterStateSnapshot
    ):
        | Observable<boolean | UrlTree>
        | Promise<boolean | UrlTree>
        | boolean
        | UrlTree {
        return true;
    }

    canLoad(
        route: Route,
        segments: UrlSegment[]
    ): Observable<boolean> | Promise<boolean> | boolean {
        // Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
        return true;
    }

    async RoleGaurd(
        route: ActivatedRouteSnapshot,
        state: RouterStateSnapshot
    ): Promise<boolean | UrlTree> {
        return await this.authService
            .getRole()
            .toPromise()
            .then((result) => {
                let data: RouterData = new RouterData();
                data = route.data as RouterData;
                let redirectTo = route.pathFromRoot
                    .filter(
                        (p) => p !== route && p.url !== null && p.url.length > 0
                    )
                    .reduce(
                        (arr, p) => arr.concat(p.url.map((u) => u.path)),
                        new Array<string>()
                    );
                if (result.success) {
                    //need to add logic for geeting role type from api
                    if (result.data.role === 'doctor') {
                        if (DOCTOR_ROLES.includes(result.data.doctor.role_id)) {
                            if (
                                data.sub_role.includes(
                                    result.data.doctor.role_id
                                )
                            ) {
                                return true;
                            } else {
                                this.router.navigate(['/' + this.slug + '/doctor', 'dashboard'], {
                                    relativeTo: this.activatedRoute
                                });
                                return false;
                            }
                        }
                        if (
                            OTHER_MEDICAL_PROFESSIONAL_ROLES.includes(
                                result.data.doctor.role_id
                            )
                        ) {
                            if (
                                data.sub_role.includes(
                                    result.data.doctor.role_id
                                )
                            ) {
                                return true;
                            } else {
                                this.router.navigate(
                                    [
                                        '/' + this.slug + '/other-medical-professionals',
                                        'dashboard'
                                    ],
                                    { relativeTo: this.activatedRoute }
                                );
                                return false;
                            }
                        }
                        if (
                            SUPPORT_ROLES.includes(
                                result.data.doctor.role_id
                            )
                        ) {
                            if (
                                data.sub_role.includes(
                                    result.data.doctor.role_id
                                )
                            ) {
                                return true;
                            } else {
                                this.router.navigate(
                                    [
                                        '/' + this.slug + '/support',
                                        'dashboard'
                                    ],
                                    { relativeTo: this.activatedRoute }
                                );
                                return false;
                            }
                        }
                        if (
                            VENDOR_ROLES.includes(
                                result.data.doctor.role_id
                            )
                        ) {
                            if (
                                data.sub_role.includes(
                                    result.data.doctor.role_id
                                )
                            ) {
                                return true;
                            } else {
                                this.router.navigate(
                                    [
                                        '/' + this.slug + '/vendor',
                                        'dashboard'
                                    ],
                                    { relativeTo: this.activatedRoute }
                                );
                                return false;
                            }
                        }
                    } else if (result.data.role === 'patient') {
                        return true;
                        if (
                            PATIENT_ROLES.includes(result.data.patient.role_id)
                        ) {
                            if (
                                data.sub_role.includes(
                                    result.data.patient.role_id
                                )
                            ) {
                                return true;
                            } else {
                                this.router.navigate(['/' + this.slug + '/patient', 'dashboard'], {
                                    relativeTo: this.activatedRoute
                                });
                                return false;
                            }
                        }
                    } else {
                        this.router.navigate(['/' + this.slug + '/accessdenied'], {
                            relativeTo: this.activatedRoute
                        });
                    }
                } else {
                    this.router.navigate(['/' + this.slug + '/accessdenied'], {
                        relativeTo: this.activatedRoute
                    });
                }
            })
            .catch((error: HttpErrorResponse) => {
                // let redirectTo = route.pathFromRoot
                //   .filter(p => p !== route && p.url !== null && p.url.length > 0)
                //   .reduce((arr, p) => arr.concat(p.url.map(u => u.path)), new Array<string>());
                // this.router.navigate(redirectTo.concat("dashboard"), { relativeTo: this.activatedRoute });
                this.router.navigate(['/' + this.slug + '/accessdenied'], {
                    relativeTo: this.activatedRoute
                });
                return false;
            });
    }
}
